import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './NotFound.css';

const NotFound = ({ user, setUser }) => {
    const navigate = useNavigate();

    return (
        <div className="notfound-container">
            <Navbar user={user} setUser={setUser} />
            <div className="notfound-content">
                <div className="notfound-error-code">404</div>
                <h1 className="notfound-title">Page Not Found</h1>
                <p className="notfound-subtitle">
                    We're sorry, but the page you are looking for does not exist or has been moved.
                </p>
                <div className="notfound-actions">
                    <button onClick={() => navigate('/')} className="btn-primary-large">
                        Return to Homepage
                    </button>
                    <button onClick={() => navigate(-1)} className="btn-secondary-large">
                        Go Back
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default NotFound;
